/**
 * OLA Cosmetics — Infinite Scroll
 * Automatically loads next page of products when user nears the bottom.
 * Falls back gracefully if JS disabled (standard pagination renders).
 */
(function () {
  'use strict';

  const TRIGGER_OFFSET = 400; // px from bottom to trigger load
  let loading = false;
  let nextPageUrl = null;

  function init() {
    const grid = document.querySelector('[data-infinite-scroll-container]');
    if (!grid) return;

    const nextLink = document.querySelector('[data-next-page-url]');
    if (!nextLink) return;

    nextPageUrl = nextLink.getAttribute('data-next-page-url');
    if (!nextPageUrl) return;

    // Hide the standard pagination when infinite scroll is active
    const pagination = document.querySelector('[data-pagination]');
    if (pagination) pagination.style.display = 'none';

    // Create and insert the spinner
    const spinner = createSpinner();
    grid.parentNode.insertBefore(spinner, grid.nextSibling);

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function onScroll() {
    if (loading || !nextPageUrl) return;

    const scrollBottom = window.scrollY + window.innerHeight;
    const docHeight = document.documentElement.scrollHeight;

    if (scrollBottom >= docHeight - TRIGGER_OFFSET) {
      loadNextPage();
    }
  }

  async function loadNextPage() {
    if (loading || !nextPageUrl) return;
    loading = true;

    const spinner = document.querySelector('[data-infinite-spinner]');
    if (spinner) spinner.style.display = 'flex';

    try {
      const res = await fetch(nextPageUrl);
      if (!res.ok) throw new Error('Network error');

      const text = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');

      // Grab new product items
      const newItems = doc.querySelectorAll('[data-infinite-scroll-container] [data-product-item]');
      const container = document.querySelector('[data-infinite-scroll-container]');

      newItems.forEach(item => {
        item.style.opacity = '0';
        item.style.transform = 'translateY(20px)';
        container.appendChild(item);

        // Animate in
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            item.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
            item.style.opacity = '1';
            item.style.transform = 'translateY(0)';
          });
        });
      });

      // Update URL without reloading
      const newNextLink = doc.querySelector('[data-next-page-url]');
      if (newNextLink) {
        nextPageUrl = newNextLink.getAttribute('data-next-page-url');
        // Update browser URL to reflect current page
        const currentPage = new URL(nextPageUrl).searchParams.get('page');
        if (currentPage) {
          const url = new URL(window.location.href);
          const prevPage = parseInt(currentPage) - 1;
          url.searchParams.set('page', prevPage);
          window.history.replaceState({}, '', url.toString());
        }
      } else {
        nextPageUrl = null;
        // Remove scroll listener — no more pages
        window.removeEventListener('scroll', onScroll);
        if (spinner) spinner.remove();
      }
    } catch (err) {
      console.error('[OLA] Infinite scroll error:', err);
      nextPageUrl = null;
      window.removeEventListener('scroll', onScroll);
    } finally {
      loading = false;
      const spinner = document.querySelector('[data-infinite-spinner]');
      if (spinner) spinner.style.display = 'none';
    }
  }

  function createSpinner() {
    const wrapper = document.createElement('div');
    wrapper.setAttribute('data-infinite-spinner', '');
    wrapper.style.cssText = `
      display: none;
      justify-content: center;
      align-items: center;
      padding: 2rem;
    `;

    const spin = document.createElement('div');
    spin.style.cssText = `
      width: 36px;
      height: 36px;
      border: 3px solid rgba(28,28,28,0.15);
      border-top-color: #494949;
      border-radius: 50%;
      animation: ola-spin 0.7s linear infinite;
    `;
    wrapper.appendChild(spin);

    // Inject keyframes once
    if (!document.getElementById('ola-spin-style')) {
      const style = document.createElement('style');
      style.id = 'ola-spin-style';
      style.textContent = '@keyframes ola-spin { to { transform: rotate(360deg); } }';
      document.head.appendChild(style);
    }

    return wrapper;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
